import React from 'react';
import { ArrowRightIcon, BriefcaseIcon, CpuIcon, GraduationCapIcon, HeartPulseIcon, RouteIcon, ScaleIcon, ShieldCheckIcon, SproutIcon, ZapIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { Button } from '../ui/Button';
import { policies } from '../../data/policies';
const icons: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  briefcase: BriefcaseIcon,
  shield: ShieldCheckIcon,
  zap: ZapIcon,
  graduation: GraduationCapIcon,
  heart: HeartPulseIcon,
  sprout: SproutIcon,
  cpu: CpuIcon,
  road: RouteIcon,
  scale: ScaleIcon
};
export function AgendaPreview() {
  return <section aria-labelledby="agenda-heading" className="bg-sand-50 py-16 sm:py-20 lg:py-28" data-id="element-132" data-mp="20hwppbvmlzvx">
      <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-133" data-mp="2xxaiorc9x47c">
        <SectionHeading eyebrow="The agenda" title="Our plan for Nigeria" intro="Nine policy areas, each with a costed plan, first-100-day actions and published targets." action={<Button variant="secondary" data-id="element-135" data-mp="1hqvpbkq7rc0b">
              View the full agenda
              <ArrowRightIcon aria-hidden className="h-[18px] w-[18px]" data-id="element-136" data-mp="1hszt82o44b0l" />
            </Button>} data-id="element-134" data-mp="2xylmus9msdyz" />

        <ul className="mt-12 grid gap-x-12 border-t border-sand-300 md:grid-cols-2" data-id="element-137" data-mp="181c3q7b4941r">
          {policies.map((policy, index) => {
          const Icon = icons[policy.icon];
          return <li key={policy.slug} data-id="element-138" data-mp="z0noj99zkxna" data-mpi={index}>
                <Reveal delay={Math.min(index, 5) * 0.03} data-id="element-139" data-mp="z1p6zytc0mf1">
                  <a href={`/agenda/${policy.slug}`} className="group flex items-start gap-4 border-b border-sand-300 py-6 transition-colors duration-150 ease-emphasis hover:bg-white" data-id="element-140" data-mp="l0wa57fk5f8r">
                    <span className="mt-0.5 flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-green-50 text-green-700 transition-colors duration-150 ease-emphasis group-hover:bg-green-600 group-hover:text-white" data-id="element-141" data-mp="2fg8i87nbo27c">
                      <Icon className="h-5 w-5" data-id="element-142" data-mp="3sbcthvrnzmzz" />
                    </span>
                    <span className="flex-1" data-id="element-143" data-mp="3nct6ds1c4561">
                      <span className="flex items-baseline gap-3" data-id="element-144" data-mp="3jchmwikpkaw5">
                        <span className="font-display text-[20px] leading-snug text-ink" data-id="element-145" data-mp="3jevfmkrx1b0j">
                          {policy.title}
                        </span>
                        <span className="text-[11px] font-bold uppercase tracking-[0.1em] text-slate-500" data-id="element-146" data-mp="exhscrk9e45c">
                          {policy.category}
                        </span>
                      </span>
                      <span className="mt-1.5 block max-w-[46ch] text-[14px] leading-relaxed text-slate-600" data-id="element-147" data-mp="64y1ida7l3v2">
                        {policy.summary}
                      </span>
                    </span>
                    <ArrowRightIcon aria-hidden className="mt-3 h-4 w-4 shrink-0 text-green-600 transition-transform duration-200 ease-emphasis group-hover:translate-x-1" data-id="element-148" data-mp="yo3bu5dg9wuk" />
                  </a>
                </Reveal>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}